<template>
  <div class="modelBox BoxSave" :class="{'showModelBox':states}">
    <div class="Box">
      <div class="modelBoxContent">
        <span class="Icon">
          <i class="iconfont icon-chenggong " v-if="state==='yes'"></i>
          <i class="iconfont icon-iconfontclosesmall " v-if="state==='no'"></i>
        </span>
        <p class="text">{{content}}</p>
      </div>
    </div>
    <div class="model" v-if="states">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xk-hintBox',
    props: ['state', 'time', 'router', 'content'],
    data () {
      return {
        states: true
      }
    },
    mounted: function () {
      let that = this
      setTimeout(function () {
        that.states = false
        if (that.$props.router) {
          that.$router.push(that.$props.router)
        }
        that.$emit('change', {})
      }, that.time ? that.time : 1000)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .BoxSave {
    width: 52vw;
    position: relative;
    z-index: -100;
    .Box {
      position: fixed;
      min-width: 46.666666%;
      max-width: 75%;
      height: auto;
      background-color: #fff;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 0.33333rem;
      overflow: hidden;
      z-index: -100;
      opacity: 0;
      transition: 0.3s all;
      text-align: center;
      .modelBoxContent {
        padding: 1rem;
      }
      .modelBoxBottom {
        height: 2.8rem;
        width: 100%;
        overflow: hidden;
        .ActionBut {
          width: 50%;
          box-sizing: border-box;
          text-align: center;
          float: left;
          line-height: 2.8rem;
        }
        .OKBut {
          background-color: #eeeeee;
          color: #bbbbbb;
          border-radius: 0 0 0 0.33333rem;
        }
        .NoBut {
          background-color: #f06553;
          color: #fff;
          border-radius: 0 0 0.33333rem 0;
        }
      }
    }
    .Icon {
      display: inline-block;
      width: 4.1rem;
      height: 4.1rem;
      border-radius: 50%;
      background-color: #f3f4f5;
      overflow: hidden;
      position: relative;
      i {
        font-size: 1.5rem;
        position: absolute;
        left: 52%;
        top: 52%;
        font-weight: bold;
        transform: translate(-50%, -50%);
      }
      .icon-chenggong {
        color: #2ba81e;
      }
      .icon-iconfontclosesmall {
        color: red;
        font-size: 1.8rem;
      }
    }
    .text {
      color: #333333;
      font-size: 1.25rem;
      margin-top: 1.6666rem;
    }
    .model {
      position: fixed;
      width: 300%;
      height: 300%;
      background: rgba(0, 0, 0, 0.5);
      left: 0;
      top: 0;
      opacity: 1;
      z-index: -100;
      transform: translate(-50%, -50%);
    }
  }

  .showModelBox {
    z-index: 777;
    .Box {
      z-index: 50;
      opacity: 1;
    }
    .model {
      opacity: 1;
      z-index: 10;
    }
  }
</style>



// WEBPACK FOOTER //
// hintBox.vue?06b91ec0